module.exports = __webpack_public_path__ + "media/images/sp/top/icon-station-46cea04cabdddd5c23c6cb4765f0cedc.png";